/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import axios from 'axios';
import env from '@/utils/env';
import store from '@/store';
var service = axios.create({
  timeout: 150000,
  headers: {
    'content-type': 'application/json'
  }
});
window.cancelTokenList = [];
var defaultRequestData = {
  version: env.appVersion,
  releaseVersion: env.releaseVersion,
  from: 'h5',
  systemCode: 'A3',
  platform: env.platformCode
};
service.interceptors.request.use(function (config) {
  config.data = config.data || {};
  Object.assign(config.data, defaultRequestData);

  if (config.data.action) {
    config.url = "".concat(config.url, "?").concat(config.data.action);
  }

  config.data.token = store.state.user.webviewToken;
  config.data.__sysTag = 'dev'; // 全局CancelToken

  var source = axios.CancelToken.source();
  source.token.throwIfRequested = source.token.throwIfRequested;
  window.cancelTokenList.push(source);
  config.cancelToken = source.token;
  return config;
}, function (error) {
  Promise.reject(error);
});
service.interceptors.response.use(function (response) {
  // 处理全局CancelToken List
  window.cancelTokenList = window.cancelTokenList.filter(function (x) {
    return x.token !== response.config.cancelToken;
  }); // 各种返回状况处理

  var res = response && response.data;
  if (res.code !== 0) throw new Error(res.msg);
  return res;
}, function (error) {
  if (error instanceof Error) {
    throw error;
  }

  throw new Error('抱歉,网络开小差了');
});
export default service;